export default __webpack_public_path__ + "static/media/MM.ddfb56cc.svg";